// extracted by mini-css-extract-plugin
var _1 = "yi_ifq1tKoicJWGHMSnu";
var _2 = "wVBoT7pTWLDwM1c7m8v3";
var _3 = "wVBoT7pTWLDwM1c7m8v3";
var _4 = "lR5ijAOlRab6ttOqplWT";
var _5 = "lR5ijAOlRab6ttOqplWT";
var _6 = "jP_OKvRIKjRhVnItQBsf";
var _7 = "jP_OKvRIKjRhVnItQBsf";
export { _1 as "handy", _2 as "sharp-star", _3 as "sharpStar", _4 as "three-x", _5 as "threeX", _6 as "two-x", _7 as "twoX" }
